export enum GameDataRoutes {
  CountGames = 'count-games',
  GeneratePlaySkeletalVideo = 'generate-play-skeletal-video',
  GetGamePitches = 'get-game-pitches',
  GetGamePlayers = 'get-game-players',
  GetGames = 'get-games',
  GetGameScore = 'get-game-score',
  GetPitches = 'get-pitches',
  GetPlayerPitches = 'get-player-pitches',
  GetPlayers = 'get-players',
  GetPlaySkeletal = 'get-play-skeletal',
  GetPlayVideos = 'get-play-videos',
  GetTeams = 'get-teams',
}
